export function removeBracketsContainingPhrase(
  text: string,
  phrase: string
): string {
  if (!text) return "";

  const escapedPhrase = phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const regex = new RegExp(`\\s?\\([^)]*\\b${escapedPhrase}\\b[^)]*\\)`, "gi");
  return text.replace(regex, "");
}
